export var pickAxisType = (_state, axisType) => axisType;